import React from "react";
import { COMPANY } from "@/lib/api";

const steps = [
  { n: "01", t: "Apply", d: "Fill out the form below. Takes about 3 minutes." },
  { n: "02", t: "Screen", d: "A recruiter reviews your info and gives you a call — usually within 2 business days." },
  { n: "03", t: "Interview", d: "Meet the operations director. Drivers ride along with a lead." },
  { n: "04", t: "Offer & Start", d: "Background + MVR check for drivers, then paid onboarding." },
];

export function HiringProcess() {
  return (
    <section className="py-16 lg:py-20 border-b border-slate-200 bg-white">
      <div className="max-w-6xl mx-auto px-6 lg:px-10">
        <div className="text-xs tracking-[0.3em] uppercase font-bold text-primary-brand mb-3">How Hiring Works</div>
        <h2 className="font-heading text-3xl md:text-4xl font-black tracking-tight text-slate-900">
          Straightforward. Respectful. Fast.
        </h2>
        <div className="mt-10 grid grid-cols-1 md:grid-cols-4 gap-px bg-slate-200 border border-slate-200">
          {steps.map((s) => (
            <div key={s.n} className="bg-white p-8">
              <div className="font-heading text-3xl font-black text-primary-brand">{s.n}</div>
              <div className="mt-2 font-heading font-bold text-slate-900">{s.t}</div>
              <div className="text-sm text-slate-600 mt-1">{s.d}</div>
            </div>
          ))}
        </div>
        <div className="mt-8 text-sm text-slate-600">
          Questions before applying? Call us at{" "}
          <a href={`tel:${COMPANY.phoneRaw}`} className="text-primary-brand font-bold hover:underline">{COMPANY.phone}</a>{" "}
          or email <a href={`mailto:${COMPANY.email}`} className="text-primary-brand font-bold hover:underline break-all">{COMPANY.email}</a>.
        </div>
      </div>
    </section>
  );
}
